// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'gene... Remove this comment to see the full error message
import { useStoreDependency } from 'general-store';
import { List, Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { threadEmailReplies } from 'conversations-thread-view-crm-events/helpers/threadEmailReplies';
import { useThreadEmailRepliesContext } from 'conversations-thread-view-crm-events/email/context/ThreadEmailRepliesContext';
import TimelineEventVirtualized from './TimelineEventVirtualized';
import TimelineLoadingObserver from './TimelineLoadingObserver';
import TimelineZeroState from './TimelineZeroState';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'crm_... Remove this comment to see the full error message
import IsUngatedStore from 'crm_data/gates/IsUngatedStore';
import { fetchV1Engagement, getIsSampleContact, getSelectedFiltersJS, isEngagementTypeId, SubjectDependency, TimelineOverrideFavoriteEventDependency, TimelineStatusStore, useFetchTimelineFilters } from 'crm-events-data';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
// @ts-expect-error FIXME: Could not find a declaration file
import { updateEngagements } from 'crm_data/engagements/EngagementsActions';
import Raven from 'raven-js';
import { UpIcon } from 'foundations-assets';
import { useElementDimensions } from 'crm-events-components/internal/observers/hooks/useElementDimensions';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import TimelineUpgradePoint from '../generic/TimelineUpgradePoint';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import styled from 'foundations-theming/utils';
import SampleEventsDeprecationBanner from '../SampleEventsDeprecationBanner';
import { getTimelineScrollContainer } from '../../helpers/getTimelineScrollContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "TimelineEventsVirtualized__StyledDiv",
  componentId: "sc-16o7sf0-0"
})(["position:fixed;inset-block-end:", ";margin-inline-start:", "px;transition:none;"], ({
  theme
}) => theme.space['500'], ({
  marginLeft
}) => marginLeft);
export const dependencies = {
  favoriteEventOverride: TimelineOverrideFavoriteEventDependency,
  timelineStatus: {
    stores: [TimelineStatusStore],
    deref: () => TimelineStatusStore.get('timelineStatus')
  },
  subject: SubjectDependency,
  isUngatedForWhatsApp: {
    stores: [IsUngatedStore],
    deref: () => IsUngatedStore.get('Conversations:WhatsApp')
  }
};
function TimelineEventsVirtualized({
  emailTabIsSelected,
  events,
  onShowMore,
  objectType,
  profileStartTime,
  subjectId,
  timelineLoadStartTime,
  onTimelineEventsChanged
}) {
  var _useElementDimensions;
  const {
    data
  } = useFetchTimelineFilters({
    subjectId,
    objectTypeOrId: objectType
  });
  const [shouldRefetch, setShouldRefetch] = useState(false);
  const selectedEventFiltersJS = data && getSelectedFiltersJS(data.crmObject.timeline.filterGroups);
  const {
    shouldThreadEmailReplies
  } = useThreadEmailRepliesContext();
  const subject = useStoreDependency(dependencies.subject, {
    objectType,
    subjectId
  });
  const timelineStatus = useStoreDependency(dependencies.timelineStatus);
  const favoriteEventOverride = useStoreDependency(dependencies.favoriteEventOverride, {
    objectType
  });
  const isUngatedForWhatsApp = useStoreDependency(dependencies.isUngatedForWhatsApp);
  useEffect(() => {
    if (shouldRefetch) {
      onTimelineEventsChanged();
      setShouldRefetch(false);
    }
  }, [onTimelineEventsChanged, shouldRefetch]);
  const onAddEngagementMessageTopic = useCallback(() => {
    setTimeout(() => {
      setShouldRefetch(true);
    }, 3000);
  }, []);
  const onUpdateObjectMessageTopic = useCallback(({
    objectId,
    objectTypeId
  }) => {
    if (!isEngagementTypeId(objectTypeId)) {
      return;
    }
    fetchV1Engagement({
      engagementId: objectId
    }).then(engagement => {
      updateEngagements(ImmutableMap().set(`${objectId}`, engagement));
    }).catch(e => {
      Raven.captureException(e, {
        tags: {
          apiError: 'Error updating timeline event'
        }
      });
    });
  }, []);
  useOnCrmMessageTopic(TOPIC_NAMES.ADD_ENGAGEMENT, onAddEngagementMessageTopic);
  useOnCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECT, onUpdateObjectMessageTopic);
  const scrollContainerRef = useRef(null);
  const [showScrollTopButton, setShowScrollTopButton] = useState(false);

  // Virtualization required this to be a calculated value
  const marginLeft = ((_useElementDimensions = useElementDimensions({
    target: scrollContainerRef.current
  }).elementDimensions.width) !== null && _useElementDimensions !== void 0 ? _useElementDimensions : 0) - 57;
  useEffect(() => {
    var _scrollContainerRef$c;
    scrollContainerRef.current = getTimelineScrollContainer();
    const handleScroll = () => {
      if (!scrollContainerRef.current) {
        return;
      }
      const scrollTop = scrollContainerRef.current.scrollTop;
      if (scrollTop > 330) {
        setShowScrollTopButton(true);
      } else {
        setShowScrollTopButton(false);
      }
    };
    (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 || _scrollContainerRef$c.addEventListener('scroll', handleScroll);
    return () => {
      var _scrollContainerRef$c2;
      (_scrollContainerRef$c2 = scrollContainerRef.current) === null || _scrollContainerRef$c2 === void 0 || _scrollContainerRef$c2.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const isThreadingEmails = useMemo(() => {
    return Boolean(emailTabIsSelected && shouldThreadEmailReplies);
  }, [emailTabIsSelected, shouldThreadEmailReplies]);
  const filteredEvents = useMemo(() => {
    let uniqueEvents = List();
    if (isUngatedForWhatsApp) {
      let eventMapByConversationType = ImmutableMap();
      events.forEach(event => {
        if (event && event.get('etype') === 'eventEngagement') {
          const eventConversationSource = event.getIn(['eventData', 'metadata', 'conversationSource']);
          const eventThreadId = event.getIn(['eventData', 'metadata', 'threadId']);
          const key = `${eventConversationSource}_${eventThreadId}`;
          if (eventConversationSource) {
            if (!eventMapByConversationType.has(key)) {
              uniqueEvents = uniqueEvents.push(event);
              eventMapByConversationType = eventMapByConversationType.set(key, true);
            } else {
              // another event with same conversation source and thread id already exists
              // so we will skip this event from showing up in the timeline
            }
          } else {
            uniqueEvents = uniqueEvents.push(event);
          }
        } else {
          uniqueEvents = uniqueEvents.push(event);
        }
      });
    } else {
      uniqueEvents = events;
    }
    if (!isThreadingEmails) {
      return uniqueEvents;
    }
    return threadEmailReplies(events);
  }, [isThreadingEmails, events, isUngatedForWhatsApp]);

  // these values should be pulled outside of useMemo/useCallback since if timelineStatus
  // is in the dependency array it will cause unnecessary recompute even if the values
  // below don't change but the object does
  const isFetching = timelineStatus.get('isFetching');
  const hasMore = timelineStatus.get('hasMore');
  const hasHiddenEvents = timelineStatus.get('hasHiddenEvents');
  const renderedEvents = useMemo(() => {
    return filteredEvents.map((event, index, collection) => {
      return /*#__PURE__*/_jsx(TimelineEventVirtualized, {
        index: index,
        timelineItem: event
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ key: any; index: any; timelineItem: any; c... Remove this comment to see the full error message
        ,
        collection: collection,
        objectType: objectType,
        profileStartTime: profileStartTime,
        subjectId: subjectId,
        timelineLoadStartTime: timelineLoadStartTime
      }, index);
    });
  }, [filteredEvents, objectType, profileStartTime, subjectId, timelineLoadStartTime]);
  const renderedTimelineLoadingObserver = useMemo(() => {
    const isShowingEmptyState = selectedEventFiltersJS && !selectedEventFiltersJS.length;
    if (!hasMore && !isFetching || isShowingEmptyState) {
      return null;
    }
    return /*#__PURE__*/_jsx(TimelineLoadingObserver, {
      isFetching: isFetching,
      shouldUseThreadedEmailFetchingLogic: isThreadingEmails,
      showMore: onShowMore
    });
  }, [hasMore, isFetching, isThreadingEmails, onShowMore, selectedEventFiltersJS]);
  const renderedScrollTopButton = useMemo(() => {
    if (!showScrollTopButton) {
      return null;
    }
    return (
      /*#__PURE__*/
      /* @bend-expect trellis-tokenized */
      _jsx(StyledDiv, {
        marginLeft: marginLeft,
        children: /*#__PURE__*/_jsx(IconButton, {
          id: "scroll-to-top",
          "data-test-id": "scroll-to-top",
          shape: "circle",
          tooltip: "Scroll to top",
          placement: "right",
          onClick: () => {
            if (scrollContainerRef.current) {
              CrmLogger.log('timelineInteractions', {
                action: 'clicked scroll to top'
              });
              scrollContainerRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }
          },
          children: /*#__PURE__*/_jsx(UpIcon, {})
        })
      })
    );
  }, [marginLeft, showScrollTopButton]);
  const renderedActivityLimitUpgradePoint = useMemo(() => {
    if (hasHiddenEvents && (selectedEventFiltersJS === null || selectedEventFiltersJS === void 0 ? void 0 : selectedEventFiltersJS.length) !== 0) {
      return /*#__PURE__*/_jsx(TimelineUpgradePoint, {
        loading: isFetching
      });
    }
  }, [hasHiddenEvents, isFetching, selectedEventFiltersJS]);
  const renderedSampleEventsDeprecationBanner = useMemo(() => {
    return /*#__PURE__*/_jsx(SampleEventsDeprecationBanner, {});
  }, []);
  if (favoriteEventOverride) {
    if (!hasMore && !hasHiddenEvents && filteredEvents.isEmpty() && !getIsSampleContact(getProperty(subject, 'email'))) {
      return /*#__PURE__*/_jsx(TimelineZeroState, {
        favoriteEventOverride: favoriteEventOverride
      });
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderedSampleEventsDeprecationBanner, renderedEvents, renderedActivityLimitUpgradePoint, renderedTimelineLoadingObserver, renderedScrollTopButton]
  });
}
export const TimelineEventsVirtualizedPropTypes = {
  emailTabIsSelected: PropTypes.bool,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  events: PropTypes.instanceOf(List),
  objectType: AnyCrmObjectTypePropType.isRequired,
  onShowMore: PropTypes.func,
  profileStartTime: PropTypes.number,
  subjectId: PropTypes.string.isRequired,
  timelineLoadStartTime: PropTypes.number
};
TimelineEventsVirtualized.propTypes = TimelineEventsVirtualizedPropTypes;
export default TimelineEventsVirtualized;